/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Stepstitle1Inputs */

const he_extension_stepstitle1 = /** @type {(inputs: Extension_Stepstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`איך זה עובד?`)
};

const en_extension_stepstitle1 = /** @type {(inputs: Extension_Stepstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Does It Work?`)
};

/**
* | output |
* | --- |
* | "How Does It Work?" |
*
* @param {Extension_Stepstitle1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_stepstitle1 = /** @type {((inputs?: Extension_Stepstitle1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Stepstitle1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_stepstitle1(inputs)
	return en_extension_stepstitle1(inputs)
});
export { extension_stepstitle1 as "extension_stepsTitle" }